import {
    createFrontendPlugin,
    PageBlueprint,
} from "@backstage/frontend-plugin-api";
import { pluginId } from "@internal/backstage-plugin-gcp-project-approvals-common";

import { rootRouteRef } from "./routes";

/**
 * Page extension mounted at `/gcp-project-approvals`. The app's page header
 * renders `title`; the view itself is lazy-loaded.
 */
export const GcpProjectApprovalsPage = PageBlueprint.make({
    params: {
        path: "/gcp-project-approvals",
        routeRef: rootRouteRef,
        title: "GCP Project Approvals",
        loader: () =>
            import("./views/GcpProjectApprovalsPage").then(m => (
                <m.GcpProjectApprovalsPage />
            )),
    },
});

const gcpProjectApprovalsPlugin = createFrontendPlugin({
    pluginId,
    routes: {
        root: rootRouteRef,
    },
    extensions: [GcpProjectApprovalsPage],
});

export default gcpProjectApprovalsPlugin;
